import React from 'react'
import styled from 'styled-components'
import noticeSrc from '../../../assets/notice.svg'

const Content = styled.div`
  margin: 3em 1em;
`
const Box = styled.div`
  background:#e8f7f6;
  background: #d2eceb;
  border-radius: 0px 4em 0px 4em;
  padding: 2em 2.5em;
  display: flex;
  justify-content: center;
  align-items: center;
  @media screen and (max-width:600px) {
    display: block;
    padding: 1em;
    font-size: .8em;
  }
`
const Picture = styled.img`
  width: 120px;
  margin-right: 2em;
  @media screen and (max-width:600px) {
    width: 50px;
    margin: auto;
    display: block;
    margin-bottom: 15px;
  }
`
const Data = styled.div`
  flex-grow: 1;
  color: var(--first);
  font-size: 1.3em;
  font-family: 'imlbold'; font-weight: bold;
  @media screen and (max-width:600px) {
    font-family: 'imlmedium';
  }
  div {
    margin-top: .6em!important;
    font-family: 'imlbold'; font-weight: bold;
  }
`
const Footer = () => {
  return (
    <Content>
      <Box>
        <Picture src={noticeSrc} />
        <Data>
          El kit utilizado para la DETECCIÓN CUALITATIVA PARA CORONAVIRUS
          SARS-CoV-2 (COVID-19) está evaluado por el InDRE.
          <div>
            Resultados el mismo día, después de las 7:00 pm.
          </div>
        </Data>
      </Box>
    </Content>
  )
}

export default Footer
